import React from 'react'
import { useSelector } from 'react-redux';
import CertificateLoader from './CertificateLoader';
import CourseLoader from './CourseLoader';
import JobLoader from './JobLoader';
import CvLoader from './CvLoader';
import CourseFreeLoader from './CourseFreeLoader';
const OnboardingLoaders = () => {
    const type = useSelector((store) => store?.onBoarding?.type) || "";
    const isPremium = useSelector((store) => store?.onBoarding?.isPremium) || false;
  return (
    type === "certificate" ? <CertificateLoader /> :
    type === "course" ? ( isPremium ? <CourseLoader /> : <CourseFreeLoader />) :
    type === "job" ? <JobLoader /> :
    type === "cv" ? <CvLoader /> : <CertificateLoader />
  )
}

export default OnboardingLoaders